import { render, staticRenderFns } from "./AdminPendingMedia.vue?vue&type=template&id=fae03d86&scoped=true&"
import script from "./AdminPendingMedia.vue?vue&type=script&lang=js&"
export * from "./AdminPendingMedia.vue?vue&type=script&lang=js&"
import style0 from "./AdminPendingMedia.vue?vue&type=style&index=0&id=fae03d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae03d86",
  null
  
)

export default component.exports